interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200/70 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onPageChange(p)}
          className={`${baseBtn} ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200/70 text-foreground-700 hover:border-primary-400 hover:text-primary-500"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200/70 disabled:hover:text-foreground-700`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}